import React from 'react'
import { Block, Typography } from '@xprog/prensa'
import { parseVariants } from 'components/Assets/Utils'
import { TitleProps } from './Title.types'

const Title: React.FC<TitleProps> = (props) => {
  return (
    <Block css={{ width: '100%' }}>
      <Typography
        as={props.as}
        css={props.customCss}
        variant={parseVariants(props.variants)}>
        {props.value || props.children}
      </Typography>
    </Block>
  )
}

Title.defaultProps = {
  as: 'h1',
  variants: ['newstitle-4xl', 'newstitle-6xl']
}

export default Title